<template>
  <HeaderSection />
  <!--
    홈이 아닌 페이지에는 main 랜드마크가 없었다 (mimio#67 landmark-one-main).
    main 태그로 바꾸지 않고 role 만 준 이유는 main.css 가 `main { ... }` 로 홈 전용
    레이아웃(padding-top/bottom, .main-text, .section01 ...)을 잡고 있어서다.
    태그를 바꾸면 전 페이지 여백이 달라진다. 홈은 Home.vue 안에 이미 main 이 있으므로
    여기서는 role 을 주지 않는다 — 두 개가 되면 그것도 실패다.
  -->
  <article
    :id="($route.name !== 'Home') ? 'pages' : ''"
    :role="($route.name !== 'Home') ? 'main' : null"
  >
    <router-view :key="$route.fullPath" />
  </article>
  <FloatingMenuBox />
  <FooterSection />
  <Login v-if="loginMode !== 'none'" />
  <GlobalOverlay/>
  <BaseModal />
</template>
<script setup>
import {computed, onMounted,} from 'vue';
import HeaderSection from '@/components/layout/Header.vue';
import FooterSection from '@/components/layout/Footer.vue';
import FloatingMenuBox from '@/components/layout/FloatingMenuBox.vue';
import Login from '@/components/auth/Login.vue';
import GlobalOverlay from "@/components/ui/GlobalOverlay.vue";
import BaseModal from '@/components/ui/BaseModal.vue';
import {useUiStore} from "@/store/useUiStore";

const uiStore = useUiStore();
const loginMode = computed(() => uiStore.loginMode);

const redirectIfWww = () => {
  const host = window.location.hostname;
  const url = window.location.href;

  if (host.startsWith('www.')) {
    const newUrl = url.replace('://www.', '://');
    window.location.replace(newUrl);
  }
};

onMounted(() => {
  redirectIfWww();

});

</script>

<style>
img,video { /* 이벤트 차단 */
  pointer-events: none;
}
</style>
